import { useMutation, useQuery, useQueryClient } from "react-query";
import {
  listAlarmButtons,
  createAlarmButton,
  updateAlarmButton,
  deleteAlarmButton,
} from "../api/AlarmButtonApi";

export const GetAlarmButtonsByOrganisationId = (orgId) => {
  return useQuery(["alarmButtons", orgId], listAlarmButtons, {
    enabled: !!orgId,
  });
};

export const CreateAlarmButton = (options) => {
  const queryClient = useQueryClient();
  return useMutation((data) => createAlarmButton(data), {
    onSuccess: (result) => {
      queryClient.invalidateQueries(["alarmButtons"]);
      if (options?.onSuccess) options.onSuccess(result);
    },
    onError: options?.onError,
  });
};

export const UpdateAlarmButton = (options) => {
  const queryClient = useQueryClient();
  return useMutation(({ id, data }) => updateAlarmButton(id, data), {
    onSuccess: (result) => {
      queryClient.invalidateQueries(["alarmButtons"]);
      if (options?.onSuccess) options.onSuccess(result);
    },
    onError: options?.onError,
  });
};

export const DeleteAlarmButton = (options) => {
  const queryClient = useQueryClient();
  return useMutation((id) => deleteAlarmButton(id), {
    onSuccess: (result) => {
      queryClient.invalidateQueries(["alarmButtons"]);
      if (options?.onSuccess) options.onSuccess(result);
    },
    onError: options?.onError,
  });
};
